import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  ReqManagerCreateActions,
  EmailValidateActions,
  UiActions
} from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { LoadingService } from './../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestEmailValidate, RequestManagerCreate } from 'src/app/shared/interfaces';
import { ApiResponseStatus, StepsNotClientTypes } from '../../../shared/enums';
import { countries } from '../../bfpe-common/data/countries';
import { civilStatuses } from '../../bfpe-common/data/civilStatuses';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { DatadogService } from 'src/app/services/datadog/datadog.service';
import { TagPage } from 'src/app/store/actions/ui.actions';

@Component({
  selector: 'lib-public-landing-foreign',
  templateUrl: './public-landing-foreign.component.html',
  styleUrls: ['../../../global.scss', './public-landing-foreign.component.scss']
})
export class PublicLandingForeignComponent implements OnInit, OnDestroy {
  today: string;
  countries: any = countries;
  civilStatuses: any = civilStatuses;
  isJointAccount: boolean;
  isForeignClient: boolean;
  formData: FormGroup;

  createRequestManager$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.reqManagerCreate)
  );

  emailValidate$ = this.store.pipe(
    select(OnboardingProductsStore.selectors.emailValidateState)
  );

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    public loadingService: LoadingService,
    private dataDogService: DatadogService,
    public sessionService: SessionService,
    private _fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.formData = this._fb.group({
      fullname: ['', Validators.required],
      surname: ['', Validators.required],
      secondSurname: ['', Validators.required],
      birthday: ['', Validators.required],
      civilStatus: [null, Validators.required],
      gender: [null, Validators.required]
    });
  }

  emailValidateSuscription = this.emailValidate$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      return this.actionClearnStateAndRedirect(EmailValidateActions);
    }
    if (this.dataNotClientService.getJointIsClient()) {
      if ((response.client && response.client.operationState.code === ApiResponseStatus.OK
        && response.joint && response.joint.operationState.code === ApiResponseStatus.OK) ||
        (response.client && response.client.operationState.code === ApiResponseStatus.DISABLE
          && response.joint && response.joint.operationState.code === ApiResponseStatus.DISABLE)
      ) {
          this.callCreateRequestManager();
      } else {
        this.store.dispatch(EmailValidateActions.cleanState());
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
      }
    } else if (this.dataNotClientService.isIsJointAccount()) {
      if (this.dataNotClientService.getJointIsClient()) {
        // TODO -> verificar, si joint es cliente datos estan en redis por llamado de cigo o pio anterior, si no se llenan en prox compo
        this.callCreateRequestManager();
      } else {
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING_FOREIGN_JOINT }));
      }
    } else {
      if (response.client && response.client.operationState.code === ApiResponseStatus.OK) {
        this.callCreateRequestManager();
      } else if (response.client && response.client.operationState.code === ApiResponseStatus.DISABLE) {
        this.callCreateRequestManager();
      } else {
        this.store.dispatch(EmailValidateActions.cleanState());
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
      }
    }
  });

  createRequestManagerSubs = this.createRequestManager$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      this.dataDogService.addCustomError(error, 'Landing Error', environment.mode, { channel: 'not client' });
      return this.actionClearnStateAndRedirect(ReqManagerCreateActions);
    }

    if (response) {
      if (response.client && response.client.operationState.code === ApiResponseStatus.OK) {
        this.callRedirectToOffer();
      } else if (response.client && response.client.operationState.code === ApiResponseStatus.FAIL) {
        this.store.dispatch(ReqManagerCreateActions.cleanState());
        this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_NO_OFFER }));
      }
    }
  });


  ngOnInit() {
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.store.dispatch(TagPage({text: 'foreign-data'}));
    const fechaActual = new Date();
    const fechaHace18Anios = new Date();
    const maxAge = fechaHace18Anios.setFullYear(fechaActual.getFullYear() - 18);
    this.today = this.datePipe.transform(maxAge, 'yyyy-MM-dd');
    this.isJointAccount = false;
  }

  ngOnDestroy() {
    this.createRequestManagerSubs.unsubscribe();
    this.emailValidateSuscription.unsubscribe();
  }

  // Metodo para limpiar el estado luego de un error de servicio.
  actionClearnStateAndRedirect(action) {
    this.store.dispatch(action.cleanState());
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_SERVICE_ERROR }));
  }

  callCreateRequestManager() {
    const request: RequestManagerCreate = {
      client: {
        fullname: this.dataNotClientService.getFullname(),
        surname: this.dataNotClientService.getSurname(),
        secondSurname: this.dataNotClientService.getSecondSurname(),
        birthday: this.dataNotClientService.getBirthday(),
        civilStatus: this.dataNotClientService.getCivilStatus(),
        gender: this.dataNotClientService.getGender()
      }
    };

    this.store.dispatch(ReqManagerCreateActions.getReqManagerCreate({ request }));
  }

  callRedirectToOffer() {
    this.store.dispatch(ReqManagerCreateActions.cleanState());
    this.dataDogService.addCustomEvent('Landing Complete', environment.mode, { channel: 'not client' });
    this.dataDogService.addCustomEvent('Has offer', environment.mode, { channel: 'not client' });
    this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_OFFER }));
  }

  callSeon() {
    const request: RequestEmailValidate = {
      client: {
        cellphone: this.dataNotClientService.getPhoneNumber(),
        email: this.dataNotClientService.getEmail()
      }
    };
    this.store.dispatch(EmailValidateActions.getEmailValidate({ request }));
  }

  continue() {
    if (this.formData.dirty === false || this.formData.invalid) {
      return null;
    }

    this.dataNotClientService.setFullname(this.formData.controls['fullname'].value);
    this.dataNotClientService.setSurname(this.formData.controls['surname'].value);
    this.dataNotClientService.setSecondSurname(this.formData.controls['secondSurname'].value);
    this.dataNotClientService.setBirthday(this.formData.controls['birthday'].value);
    this.dataNotClientService.setCivilStatus(parseInt(this.formData.controls['civilStatus'].value, 10));
    this.dataNotClientService.setGender(parseInt(this.formData.controls['gender'].value, 10));
    this.loadingService.loading = true;

    if (this.dataNotClientService.isIsJointAccount() &&
    !this.dataNotClientService.getJointIsClient() && this.dataNotClientService.jointIsForeign()) {
      return this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING_FOREIGN_JOINT }));
    } else {
      this.callCreateRequestManager();
    }

  }
}
